import { Paper } from '@mui/material';
import { Box } from '@mui/system';
import { useNavigate } from 'react-router-dom';

import ForgotPassword from '~/containers/ForgotPassword';

function ForgotPasswordPage() {
  const navigate = useNavigate();

  return (
    <Box ml={2} mr={2}>
      <Paper elevation={3} style={{ padding: '15px 0', borderRadius: 20, maxWidth: 450, margin: '100px auto' }}>
        <ForgotPassword
          onSignInClicked={() => {
            navigate('/login');
          }}
          onSignUpClicked={() => {
            navigate('/register');
          }}
        />
      </Paper>
    </Box>
  );
}

export default ForgotPasswordPage;
